/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetConsigneeAttachmentsResponse } from '../../models/get-consignee-attachments-response';
import { KeyType } from '../../models/key-type';

export interface GetConsigneeReceiptsForDeliveryNote$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
}

export function getConsigneeReceiptsForDeliveryNote(http: HttpClient, rootUrl: string, params: GetConsigneeReceiptsForDeliveryNote$Params, context?: HttpContext): Observable<StrictHttpResponse<GetConsigneeAttachmentsResponse>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeReceiptsForDeliveryNote.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetConsigneeAttachmentsResponse>;
    })
  );
}

getConsigneeReceiptsForDeliveryNote.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/receipts';
